import { useState } from 'react'
import { FluentModal } from '../../Modals/FluentModal/FluentModal'
import PeriodReportSelector from './PeriodReportSelector'
import SaveSnapshot from '../../Modals/FluentModal/Content/Confirmation/SaveSnapshot'

const ProjektprognosSnapshots = () => {
  const [isSnapshotModalOpen, setIsSnapshotModalOpen] = useState<boolean>(false) //Todo remove modual
  const [saveIsLoading, setSaveIsLoading] = useState(false)

  const modalStyleOverrides = {
    surface: {
      maxWidth: '350px',
      minWidth: '300px',
      width: 'auto',
    },
  }

  return (
    <>
      <PeriodReportSelector />
      <FluentModal
        isModalOpen={isSnapshotModalOpen}
        setIsModalOpen={saveIsLoading ? undefined : setIsSnapshotModalOpen}
        isModeLess={false}
        modalHeader={'Spara historik'}
        modalContent={
          <SaveSnapshot
            setIsModalOpen={setIsSnapshotModalOpen}
            setSaveIsLoading={setSaveIsLoading}
          />
        }
        styleOverrides={modalStyleOverrides}
      />
    </>
  )
}

export default ProjektprognosSnapshots
